module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.df2c871e.ttf";